@use '@fukuri-admins/ui/layout' as *;

.stack {
  display: flex;
  flex-grow: 0;
}

.row {
  flex-direction: row;
}

.column {
  flex-direction: column;
}

.spacing0 {
  gap: spacing('0');
}

.spacing2 {
  gap: spacing('2');
}

.spacing4 {
  gap: spacing('4');
}

.spacing6 {
  gap: spacing('6');
}

.spacing8 {
  gap: spacing('8');
}

.spacing12 {
  gap: spacing('12');
}

.spacing16 {
  gap: spacing('16');
}

.spacing20 {
  gap: spacing('20');
}

.spacing24 {
  gap: spacing('24');
}

.spacing32 {
  gap: spacing('32');
}

.spacing40 {
  gap: spacing('40');
}

.spacing48 {
  gap: spacing('48');
}

.spacing56 {
  gap: spacing('56');
}

.spacing72 {
  gap: spacing('72');
}

.spacing88 {
  gap: spacing('88');
}

.spacing104 {
  gap: spacing('104');
}

.spacing120 {
  gap: spacing('120');
}
